"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _DataTable = require("../DataTable");
var _excluded = ["additionOptions", "removalOptions"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var BODY_ROW_HOVER_CLASS_NAME = 'cds-DataTable-BodyRow--Hover';
var WithContainer = function WithContainer(_ref) {
  var additionOptions = _ref.additionOptions,
    removalOptions = _ref.removalOptions,
    originalProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isHoverable = originalProps.isHoverable,
    rows = originalProps.rows;
  var _useState = (0, _react.useState)((0, _toConsumableArray2["default"])(Array(rows.length).keys())),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentRowIndexes = _useState2[0],
    setRowCurrentIndexes = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    addedRows = _useState4[0],
    setAddedRows = _useState4[1];
  (0, _react.useEffect)(function () {
    setRowCurrentIndexes((0, _toConsumableArray2["default"])(Array(rows.length).keys()));
  }, [rows.length]);
  var handleDeleteButtonClick = (0, _react.useCallback)(function (deleteIndex) {
    setRowCurrentIndexes(currentRowIndexes.filter(function (index) {
      return index !== deleteIndex;
    }));
    removalOptions && removalOptions.callback && removalOptions.callback();
  }, [removalOptions, currentRowIndexes]);
  var createDeleteButton = (0, _react.useCallback)(function (deleteIndex) {
    if (removalOptions) {
      return /*#__PURE__*/_react["default"].cloneElement(removalOptions.button, {
        onClick: function onClick(e) {
          e.stopPropagation();
          handleDeleteButtonClick(deleteIndex);
        }
      });
    }
    return null;
  }, [handleDeleteButtonClick, removalOptions]);
  var handleAddButtonClick = (0, _react.useCallback)(function () {
    if (additionOptions && additionOptions.addingRow) {
      setAddedRows([].concat((0, _toConsumableArray2["default"])(addedRows), [additionOptions.addingRow]));
      setRowCurrentIndexes([].concat((0, _toConsumableArray2["default"])(currentRowIndexes), [currentRowIndexes.length > 0 ? Math.max(currentRowIndexes[currentRowIndexes.length - 1] + 1, rows.length) : rows.length]));
      additionOptions.callback && additionOptions.callback();
    }
  }, [addedRows, additionOptions, currentRowIndexes, rows.length]);
  var createAddButton = (0, _react.useCallback)(function () {
    if (additionOptions) {
      return additionOptions.addingRow ? /*#__PURE__*/_react["default"].cloneElement(additionOptions.button, {
        onClick: function onClick() {
          return handleAddButtonClick();
        }
      }) : additionOptions.button;
    }
    return null;
  }, [additionOptions, handleAddButtonClick]);
  var setRowHover = function setRowHover(e, row, hoverAction) {
    if (row.hasSubRow) {
      // @ts-ignore
      e.currentTarget.nextSibling.classList[hoverAction](BODY_ROW_HOVER_CLASS_NAME);
    }
    if (row.isSubRow) {
      // @ts-ignore
      e.currentTarget.previousSibling.classList[hoverAction](BODY_ROW_HOVER_CLASS_NAME);
    }
  };
  var handleRowMouseEnter = (0, _react.useCallback)(function (callback, row) {
    return function (e) {
      if (isHoverable) {
        setRowHover(e, row, 'add');
      }
      callback && callback();
    };
  }, [isHoverable]);
  var handleRowMouseLeave = (0, _react.useCallback)(function (row) {
    return function (e) {
      if (isHoverable) {
        setRowHover(e, row, 'remove');
      }
    };
  }, [isHoverable]);
  var injectedProps = {
    addedRows: addedRows,
    areRowsRemovable: !!removalOptions,
    createAddButton: createAddButton,
    createDeleteButton: createDeleteButton,
    currentRowIndexes: currentRowIndexes,
    isRowAddable: !!additionOptions,
    onRowMouseEnter: handleRowMouseEnter,
    onRowMouseLeave: handleRowMouseLeave
  };
  return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;